import { connect } from 'react-redux';
import GetReportModal from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(GetReportModal);
